import { render, staticRenderFns } from "./ImersaoChaveMestra.vue?vue&type=template&id=4b1768c0&scoped=true"
import script from "./ImersaoChaveMestra.vue?vue&type=script&lang=js"
export * from "./ImersaoChaveMestra.vue?vue&type=script&lang=js"
import style0 from "./ImersaoChaveMestra.vue?vue&type=style&index=0&id=4b1768c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1768c0",
  null
  
)

export default component.exports